const LOCATION_CACHE_KEY = 'case_location_options';

export const getLocationOptions = (): string[] => {
  const cached = localStorage.getItem(LOCATION_CACHE_KEY);
  if (!cached) {
    return [];
  }

  try {
    const parsed = JSON.parse(cached);
    if (Array.isArray(parsed)) {
      return parsed as string[];
    }
  } catch {
    // Ignore JSON parse errors and fall back to empty array.
  }

  return [];
};

export const setLocationOptions = (locations: string[]): void => {
  localStorage.setItem(LOCATION_CACHE_KEY, JSON.stringify(locations));
};
